module.exports = __webpack_public_path__ + "img/42_23.785ef8d1.png";